// Слайдер с эффектом увеличения
(() => {
  function initMobileGallerySlider(root = document) {
    const carousel = root.querySelector('#paintings-carousel');

    if (!carousel || carousel.dataset.sliderInitialized === 'true') {
      return;
    }

    const slides = [...carousel.querySelectorAll('#paintings-track .painting-slide')];

    if (slides.length === 0) {
      return;
    }

    carousel.dataset.sliderInitialized = 'true';

    const autoplayDelay = 3500;
    const swipeThreshold = 50;

    let currentIndex = 0;
    let autoplayTimer = null;
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    let moved = false;
    let isInView = false;

    function getIndex(index) {
      return (index + slides.length) % slides.length;
    }

    function renderSlides(direction = 1) {
      slides.forEach((slide) => {
        slide.classList.remove('is-active', 'is-prev', 'is-next', 'is-hidden-left', 'is-hidden-right');
      });

      const activeIndex = getIndex(currentIndex);

      slides[activeIndex].classList.add('is-active');

      if (slides.length === 1) {
        return;
      }

      if (slides.length === 2) {
        slides[getIndex(currentIndex + 1)].classList.add('is-next');
        return;
      }

      const prevIndex = getIndex(currentIndex - 1);
      const nextIndex = getIndex(currentIndex + 1);

      slides[prevIndex].classList.add('is-prev');
      slides[nextIndex].classList.add('is-next');

      slides.forEach((slide, index) => {
        if (index !== activeIndex && index !== prevIndex && index !== nextIndex) {
          slide.classList.add(direction > 0 ? 'is-hidden-right' : 'is-hidden-left');
        }
      });
    }

    function nextSlide() {
      if (slides.length < 2) {
        return;
      }

      currentIndex = getIndex(currentIndex + 1);
      renderSlides(1);
    }

    function previousSlide() {
      if (slides.length < 2) {
        return;
      }

      currentIndex = getIndex(currentIndex - 1);
      renderSlides(-1);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();

      if (!isInView || slides.length < 2) {
        return;
      }

      autoplayTimer = setInterval(nextSlide, autoplayDelay);
    }

    carousel.addEventListener('pointerdown', (event) => {
      if (slides.length < 2 || (event.pointerType === 'mouse' && event.button !== 0)) {
        return;
      }

      isDragging = true;
      moved = false;
      startX = event.clientX;
      currentX = startX;

      stopAutoplay();

      carousel.setPointerCapture(event.pointerId);
    });

    carousel.addEventListener('pointermove', (event) => {
      if (!isDragging) {
        return;
      }

      currentX = event.clientX;

      if (Math.abs(currentX - startX) > 5) {
        moved = true;
      }
    });

    function finishDrag() {
      if (!isDragging) {
        return;
      }

      isDragging = false;

      const distance = currentX - startX;

      if (Math.abs(distance) >= swipeThreshold) {
        if (distance < 0) {
          nextSlide();
        } else {
          previousSlide();
        }
      }

      startAutoplay();
    }

    carousel.addEventListener('pointerup', finishDrag);
    carousel.addEventListener('pointercancel', finishDrag);

    carousel.addEventListener(
      'click',
      (event) => {
        if (moved) {
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }
      },
      true,
    );

    const observer = new IntersectionObserver(
      ([entry]) => {
        isInView = entry.isIntersecting && entry.intersectionRatio >= 0.35;

        if (isInView) {
          startAutoplay();
        } else {
          stopAutoplay();
        }
      },
      {
        threshold: [0, 0.35],
      },
    );

    renderSlides(1);
    observer.observe(carousel);
  }

  function init(root = document) {
    initMobileGallerySlider(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
